var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAuditoryClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 56,
    viewBox: "0 0 248 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124 12.8066V27.8066H135.25M146.5 27.8066C146.5 30.7614 145.918 33.6872 144.787 36.417C143.657 39.1468 141.999 41.6272 139.91 43.7165C137.821 45.8059 135.34 47.4632 132.61 48.5939C129.881 49.7247 126.955 50.3066 124 50.3066C121.045 50.3066 118.119 49.7247 115.39 48.5939C112.66 47.4632 110.179 45.8059 108.09 43.7165C106.001 41.6272 104.343 39.1468 103.213 36.417C102.082 33.6872 101.5 30.7614 101.5 27.8066C101.5 21.8393 103.871 16.1163 108.09 11.8967C112.31 7.67717 118.033 5.30664 124 5.30664C129.967 5.30664 135.69 7.67717 139.91 11.8967C144.129 16.1163 146.5 21.8393 146.5 27.8066Z",
    stroke: "#8B5CF6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuditoryClock);
export default __webpack_public_path__ + "static/media/icon-auditory-clock.b09b72094ebd3ffb0748db27ec8b62f2.svg";
export { ForwardRef as ReactComponent };